module.exports = __webpack_public_path__ + "static/media/lic.7d0a5a20.png";